export default __webpack_public_path__ + "static/media/format_study2.57955d28.svg";